import {ChevronDown} from 'lucide-react'
import { SITE } from "@/data/site"

function Hero() {
  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-[#0a0c10]">
      <picture>
        <source media="(max-width: 767px)" srcSet={SITE.heroMobile} />
        <img
          src={SITE.hero}
          alt="Wild Thing"
          className="absolute inset-y-0 left-4 right-4 h-full object-cover object-center md:inset-0 md:w-full md:object-contain"
        />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#080808]/90" />
      <div className="relative z-10 flex min-h-screen w-full flex-col justify-end px-8 pb-24 pt-32 md:px-16 md:pb-20 lg:px-28">
        <p className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]">01</p>
        <h1 className="font-display mt-6 max-w-[18ch] whitespace-nowrap text-[9vw] leading-[0.92] tracking-[0.04em] text-[#f7f1e6] md:text-6xl lg:text-7xl">
          {SITE.brandDisplay}
        </h1>
        <p className="font-serif-tc mt-6 whitespace-nowrap text-base tracking-[0.22em] text-stone-200">
          {SITE.artist}
        </p>
        <div className="mt-14 flex flex-col gap-10 md:mt-14 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-sans-ui whitespace-nowrap text-xs tracking-[0.48em] text-stone-400">
              {SITE.edition}
            </p>
            <p className="font-serif-tc mt-2 whitespace-nowrap text-base text-stone-100 md:text-lg">
              {SITE.editionLabel}
            </p>
          </div>
          <p className="font-display mx-auto whitespace-nowrap text-center text-lg italic leading-snug text-[#f4efe6] md:absolute md:left-1/2 md:bottom-24 md:mx-0 md:-translate-x-1/2 md:text-3xl lg:bottom-20">
            {SITE.tagline}
          </p>
        </div>
      </div>
      <a
        href="#about"
        className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2 text-stone-400 transition-colors duration-500 hover:text-[#c4a574]"
      >
        <span className="font-sans-ui text-[10px] tracking-[0.4em]">SCROLL</span>
        <ChevronDown className="h-4 w-4 animate-pulse" aria-hidden="true" />
      </a>
    </section>
  )
}

export default Hero
